import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { StyleSheet, View } from "react-native";
// This component will render a page which overflows the screen
// if the container fills the body by comparing the size
// This lets the document.body handle scrolling of the content
// It's necessary for mobile browsers to be able to hide address bar on scroll
export default /*#__PURE__*/ React.forwardRef(function CardSheet(_param, ref) {
    var enabled = _param.enabled, layout = _param.layout, style = _param.style, rest = _object_without_properties(_param, [
        "enabled",
        "layout",
        "style"
    ]);
    var _React_useState = _sliced_to_array(React.useState(false), 2), fill = _React_useState[0], setFill = _React_useState[1];
    // To avoid triggering a rerender in Card during animation we had to move
    // the state to CardSheet. The `setPointerEvents` is then hoisted back to the Card.
    var _React_useState1 = _sliced_to_array(React.useState("auto"), 2), pointerEvents = _React_useState1[0], setPointerEvents = _React_useState1[1];
    React.useImperativeHandle(ref, function() {
        return {
            setPointerEvents: setPointerEvents
        };
    });
    React.useEffect(function() {
        if (typeof document === "undefined" || !document.body) {
            // Only run when DOM is available
            return;
        }
        var width = document.body.clientWidth;
        var height = document.body.clientHeight;
        setFill(width === layout.width && height === layout.height);
    }, [
        layout.height,
        layout.width
    ]);
    return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, rest), {
        pointerEvents: pointerEvents,
        style: [
            enabled && fill ? styles.page : styles.card,
            style
        ]
    }));
});
var styles = StyleSheet.create({
    page: {
        minHeight: "100%"
    },
    card: {
        flex: 1,
        overflow: "hidden"
    }
});
